import { connect } from "react-redux";
import { IGlobalState } from "../reducers/IndexReducer";
import BullCodeSelector from "../components/BullCodeSelector";
import { fetchBullOptions } from "../actions/BullCodeActions";
import { fetchCalculatedTableRows } from "../actions/TableActions";

const mapStateToProps = (state: IGlobalState) => ({
  csvData: state.csvUploaderState.csvData,
  isValid: state.csvUploaderState.isValid,
  inbreedingCalcs: state.inbreedingState.calculatedTableRows,
  bullOptions: state.bullCodes.bullOptions,
  selectedBulls: state.bullCodes.selectedBulls,
});

const mapDispatchToProps = {
  fetchBullOptions,
  fetchCalculatedTableRows,
};

export default connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps
)(BullCodeSelector);



// WEBPACK FOOTER //
// ./src/scripts/containers/BullCodeSelectorContainer.ts